import request from '@/network/request'
//发送验证码
export function LoginAs(data) {
    return request({
        url: '/Login/Send',
        headers: {
            isToken: false
        },
        method: 'post',
        data
    })
}
export function Register(data) {
    return request({
        url: '/Login/Register',
        headers: {
            isToken: false
        },
        method: 'post',
        data
    })
}